import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomCheckbox from "components/CustomCheckbox/CustomCheckbox.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// services
import userService from "services/user.service";
import levelService from "services/level.service";
// util
import Notifications from "views/Notifications/Notifications";

const styles = (theme) => ({
	cardCategoryWhite: {
		color: "rgba(255,255,255,.62)",
		margin: "0",
		fontSize: "14px",
		marginTop: "0",
		marginBottom: "0",
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
	},
});

class MatricularAlunos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uid: props.uid,
			levels: [],
			selectedLevels: [],
			notification: { show: false, message: "", type: "info" },
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSearch();
	}

	handleSearch() {
		const tableLevels = [];

		levelService
			.listAllLevels()
			.then((levels) => {
				levels.reverse().forEach((level) => {
					tableLevels.push({
						key: level.key,
						value: level.key,
						label: `${level.title} - ${level.key}`,
					});
				});

				this.setState({ levels: tableLevels });

				return userService.listOneUser(this.state.uid);
			})
			.then((userLesson) => {
				this.setState({
					selectedLevels: Object.values(userLesson.levels),
				});
			})
			.catch((err) => console.error);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.value;

		let selectedLevels;
		if (this.state.selectedLevels.length === 0) selectedLevels = [];
		else selectedLevels = this.state.selectedLevels;

		const level = selectedLevels.find((level) => level === value);
		if (!level) selectedLevels.push(value);
		else
			selectedLevels.splice(
				selectedLevels.findIndex((e) => e === level),
				1
			);

		this.setState({
			selectedLevels: selectedLevels,
		});
	}

	handleSubmit(event) {
		userService
			.addLevels(this.state.uid, this.state.selectedLevels)
			.then((res) =>
				this.showNotification(
					"Livro adicionado com sucesso!",
					"success"
				)
			)
			.catch((err) =>
				this.showNotification(
					"Ocorreu um erro ao tentar adicionar livro ao aluno! " +
						err,
					"danger"
				)
			);
	}

	showNotification(message, type) {
		this.setState({
			notification: { show: true, message: message, type: type },
		});
		setTimeout(() => {
			this.setState({
				notification: { show: false, message: "", type: "info" },
			});
			this.props.onClose();
		}, 3000);
	}

	render() {
		const { classes } = this.props;
		return (
			<div>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12}>
						<Card>
							<CardHeader color="primary">
								<h4 className={classes.cardTitleWhite}>
									Gerenciar Livros do Aluno{" "}
								</h4>
								<p className={classes.cardCategoryWhite}>
									Selecione os livros liberados para o aluno
									correspondente
								</p>
							</CardHeader>
							<CardBody>
								<GridContainer>
									<GridItem xs={12} sm={12} md={12}>
										<CustomCheckbox
											id="level"
											formControlProps={{
												fullWidth: true,
											}}
											inputProps={{
												onChange: this.handleChange,
											}}
											checkboxItems={this.state.levels}
											selectedItems={
												this.state.selectedLevels
											}
										/>
									</GridItem>
								</GridContainer>
							</CardBody>
							<CardFooter>
								<Button
									color="primary"
									type="submit"
									round
									onClick={(event) => {
										this.handleSubmit(event);
									}}
								>
									Adicionar
								</Button>
							</CardFooter>
						</Card>
					</GridItem>
					{this.state.notification.show === true ? (
						<Notifications notification={this.state.notification} />
					) : null}
				</GridContainer>
			</div>
		);
	}
}

MatricularAlunos.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MatricularAlunos);
